// utils/downloadCSV.js

const users = [
  {
    batchName: "CSE Final Year A",
    tag1: "2026 Batch",
    tag2: "Final Year",
    tag3: "Section A",
    tag4: "Placement Cell",
    tag5: "Morning Shift",
    tag6: "Campus Drive",
    description:
      "Final year Computer Science students preparing for campus placements and project submissions.",
  },
];

const customCsvData = users.map((item, index) => ({
  "Batch ID": index + 1,
  "Batch Name": item.batchName,
  "Tag 1": item.tag1,
  "Tag 2": item.tag2,
  "Tag 3": item.tag3,
  "Tag 4": item.tag4,
  "Tag 5": item.tag5,
  "Tag 6": item.tag6,
  Description: item.description,
}));

const convertToCSV = (data) => {
  if (!data || !data.length) return "";

  const headers = Object.keys(data[0]).join(",");

  const rows = data.map((row) =>
    Object.values(row)
      .map((value) => `"${value}"`)
      .join(","),
  );

  return [headers, ...rows].join("\n");
};

const downloadCSV = (userObject, fileName = "data.csv") => {
  const csv = convertToCSV(userObject);

  const blob = new Blob([csv], {
    type: "text/csv;charset=utf-8;",
  });

  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;

  document.body.appendChild(a);
  a.click();

  document.body.removeChild(a);

  window.URL.revokeObjectURL(url);
};

export { downloadCSV, convertToCSV };
